import * as S from "./Grid.style";
import { GridRow } from "@/components/atoms/GridRow";

interface GridProps {
  data?: any;
}

export const Grid = ({ data }: GridProps) => {
  return (
    <S.GridBox>
      <table>
        <tbody>
          {data.map((item: any, idx: number) => {
            return <GridRow key={idx} data={item} />;
          })}
        </tbody>
      </table>
    </S.GridBox>
  );
};
